export enum GOAL_TYPE_VALUE {
  QUANTITY = 1,
  MONETARY
}
